import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9 16V10H5L12 3L19 10H15V16H9ZM5 20V18H19V20H5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Upload"
);
